module.exports = __webpack_public_path__ + "img/alfattah.d82491fc.jpg";